import { MutationTree, ActionTree } from "vuex";
import { Currency, ColorStyle } from "../types/enums";
import { getDefaultTheme } from "@/utils/helper";
import axios from "axios";
import { CONFIGS } from "@/constants";

const state = () => ({
  inited: false,
  initing: false,
  bottomNav: "",
  layout: "default-layout",

  // FoxONE 账号迁移设置项
  needFoxoneMigrate: false,
  notShowMigrateThisSession: false,
  currentPageNeedFoxoneMigrate: false,

  // 当前页面需要授权
  currentPageNeedAuth: false,

  // 当前页面需要绑定 Mixin
  currentPageNeedMixinBind: false,

  // Mixin 授权过期
  mixinLoginOutDate: false,

  // approved / rejected / none
  legalRiskState: "none",

  config: {},
  appbar: {
    title: "",
    show: true,
    back: false
  },
  settings: {
    currency: Currency.USD,
    colorStyle: ColorStyle.GREEN_DOWN_RED_UP,
    navbarAnimationEnabled: true,
    hideTinyAssets: false,
    dark: getDefaultTheme()
  },
  toast: {
    show: false,
    color: "info",
    message: ""
  },
  paying: {
    visible: false,
    timer: null
  }
});

export type AppState = ReturnType<typeof state>;

const mutations: MutationTree<AppState> = {
  SET_LAYOUT(state, value) {
    state.layout = value;
  },
  SET_TOAST(state, { message = "", color = "info", show = true }) {
    state.toast.show = show;
    state.toast.message = message;
    state.toast.color = color;
  },
  SET_APPBAR(state, value) {
    const defaultValue = {
      title: "",
      style: "",
      show: true,
      back: true
    };
    state.appbar = { ...defaultValue, ...value };
  },
  SET_BOTTOM_NAV(state, value) {
    state.bottomNav = value;
  },
  SET_SETTINGS(state, value) {
    state.settings = value;
  },
  SET_PAYING(state, data) {
    state.paying = { ...state.paying, ...data };
    if (data.visible === false) {
      clearTimeout(state.paying.timer as any);
    }
  },
  SET_CONFIG(state, data) {
    state.config = data;
  },
  SET_INITED(state, value) {
    state.inited = value;
  },
  SET_INITING(state, value) {
    state.initing = value;
  },
  SET_CURRENT_PAGE_NEED_AUTH(state, value) {
    state.currentPageNeedAuth = value;
  },
  SET_NEED_FOXONE_MIGRATE(state, value) {
    state.needFoxoneMigrate = value;
  },
  SET_MIXIN_LOGIN_OUTDATE(state, value) {
    state.mixinLoginOutDate = value;
  },
  SET_CURRENT_PAGE_NEED_FOXONE_MIGRATE(state, value) {
    state.currentPageNeedFoxoneMigrate = value;
  },
  SET_NOT_SHOW_MIGRATE_THIS_SESSION(state, value) {
    state.notShowMigrateThisSession = value;
  },
  SET_CURRENT_PAGE_NEED_MIXIN_BIND(state, value) {
    state.currentPageNeedMixinBind = value;
  },
  SET_LEGAL_RISK_STATE(state, value) {
    state.legalRiskState = value;
  }
};

const actions: ActionTree<AppState, {}> = {
  async loadConfig({ commit }) {
    const config = await this.$api.account.getConfig();
    let res: any = {};

    try {
      const resp = await axios.get(`${CONFIGS.WEB_HOST}/static.json`);

      res = resp.data;
    } catch (error) {
      // ignore
    }

    commit("SET_CONFIG", { ...config, ...res });
  },
  removeAppInfo({ commit }) {
    commit("SET_CONFIG", {});
    commit("SET_INITED", false);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
